// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendance-view {
  overflow: hidden;
}

.attendance-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  background: var(--ui-surface-soft);
  padding: 0.65rem 0.8rem;
  font-weight: 600;
  color: var(--ui-text);
  cursor: pointer;
}

.attendance-section-toggle + .attendance-section-panel {
  margin-top: 0.6rem;
}

.attendance-section-panel[hidden] {
  display: none;
}

@media (max-width: 960px) {
  .attendance-view {
    padding: 0.95rem;
  }

  .attendance-export-item {
    grid-template-columns: auto 1fr;
    gap: 0.5rem;
  }

  .attendance-export-status {
    justify-self: flex-start;
  }

  .attendance-group .attendance-table-row {
    padding: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-reportes.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".attendance-view {\n  overflow: hidden;\n}\n\n.attendance-section-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  background: var(--ui-surface-soft);\n  padding: 0.65rem 0.8rem;\n  font-weight: 600;\n  color: var(--ui-text);\n  cursor: pointer;\n}\n\n.attendance-section-toggle + .attendance-section-panel {\n  margin-top: 0.6rem;\n}\n\n.attendance-section-panel[hidden] {\n  display: none;\n}\n\n@media (max-width: 960px) {\n  .attendance-view {\n    padding: 0.95rem;\n  }\n\n  .attendance-export-item {\n    grid-template-columns: auto 1fr;\n    gap: 0.5rem;\n  }\n\n  .attendance-export-status {\n    justify-self: flex-start;\n  }\n\n  .attendance-group .attendance-table-row {\n    padding: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
